import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { MyteamsService } from '../../Model/Module/MyTeams/myteams.service';
import { SessionService } from '../../Util/Session/session.service';
import { CommonService } from '../../Model/Common/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewReporteemployeeComponent } from '../view-reporteemployee/view-reporteemployee.component';
import { AttendanceviewComponent } from '../attendanceview/attendanceview.component';
import { ReporteeAttendanceComponent } from '../reportee-attendance/reportee-attendance.component';

@Component({
  selector: 'app-myteam',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, LoaderComponent],
  templateUrl: './myteam.component.html',
  styleUrl: './myteam.component.scss'
})
export class MyteamComponent {
  isDisabled: boolean = false
  user: any;
  RepoteesLoad: any[] = []
  RepoteesLoadMain: any[] = []
  ProfileLoad: any[] = []
  ProfileID: number = 0
  Search: string = ''
  constructor(
    private session: SessionService,
    protected common: CommonService,
    private myteam: MyteamsService,
    private modalService: NgbModal,
  ) {
    this.user = this.session.GetUserDetails();
  }


  ngOnInit() {
    this.MyTeams('Reportees', this.user.UserId);
    this.MyTeams('Profile', this.user.UserId);
  }


  MyTeams(SelectType: String, EmpmasterID: any) {
    this.RepoteesLoad = [];
    this.ProfileLoad = [];
    this.isDisabled = true
    this.ProfileID = EmpmasterID;
    this.myteam.Mobile_ESS_MyTeam({
      EmpType: '',
      SelectType: SelectType,
      EmpmasterID: EmpmasterID,
      FromDate: '',
      ToDate: '',
      SiteID: '',
      AttendanceType: '',
    }).subscribe({
      next: (response) => {
        if (SelectType === 'Reportees') {
          if (response.ESS_MyTeam_View.length > 0) {
            this.RepoteesLoad = response.ESS_MyTeam_View
             this.RepoteesLoadMain = response.ESS_MyTeam_View
          }
        }
        else if (SelectType === 'Profile') {
          if (response.ESS_MyTeam_View.length > 0) {
            this.ProfileLoad = response.ESS_MyTeam_View
          }
        }
        this.isDisabled = false
      },
      complete: () => { this.isDisabled = false },
      error: (error) => { this.isDisabled = false },
    });
  }
  ViewProfile() {
    const modalRef = this.modalService.open(ViewReporteemployeeComponent, { centered: true, backdrop: 'static', size: 'lg' });
    modalRef.componentInstance.InputData = {
      EmpName: this.ProfileLoad[0].FullName,
      EmpCode: this.ProfileLoad[0].EmpCode,
      DesignationName: this.ProfileLoad[0].DesignationName,
      Email: this.ProfileLoad[0].Email,
      Contact: this.ProfileLoad[0].ContactNo1,
      BranchName: this.ProfileLoad[0].BranchNAME,
      ReportingPersonName: this.ProfileLoad[0].ReportingPersonName,
      BirthDate: this.ProfileLoad[0].BirthDate,
      DateofJoining: this.ProfileLoad[0].DateofJoining,
      DateOfConfirmation: this.ProfileLoad[0].DateOfConfirmation,
      TotalWorkExperience: this.ProfileLoad[0].TotalWorkExperience,
      Photo: this.ProfileLoad[0].Photo
    };
    modalRef.result.then((result) => {
      if (result) {

      }
    }).catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
  }
  AttendanceView(element: any) {
    const modalRef = this.modalService.open(AttendanceviewComponent, { centered: true, backdrop: 'static', size: 'xl' });
    const shortPath = element.Photo ? element.Photo.split("/").slice(-2).join("/") : '';
    modalRef.componentInstance.InputData = {
      EmpmasterID: element.EmpMasterID,
      Photo: shortPath,//element.Photo,
      EmpName: element.FullName,
      EmpCode: element.EmpCode,
      DesignationName: element.DesignationName,
    }
    modalRef.result.then((result) => {

    }).catch((reason) => {
      console.log('Modal dismissed', reason)
    })
  }
  ViewAttendance() {
    const modalRef = this.modalService.open(ReporteeAttendanceComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.InputData = {
      ProfileID: this.ProfileID,
      EmpType: this.ProfileLoad[0].EmpType,
      ClientID : this.ProfileLoad[0].ClientID,
      SiteID : this.ProfileLoad[0].SiteID
    }
    modalRef.result.then((result) => {
    }).catch((reason) => {
      console.log('Modal dismissed', reason)
    })
  }

  SearchData() {
    const searchText = this.Search?.toLowerCase().trim() || '';
   // let data = []
    if (searchText !== '') {
      this.RepoteesLoad = this.RepoteesLoadMain.filter(p => {
        return (
          p.FullName?.toLowerCase().includes(searchText) ||
          p.EmpCode?.toLowerCase().includes(searchText) ||
          p.DesignationName?.toLowerCase().includes(searchText)
        )
      })
      //this.RepoteesLoad = data
    } else {
      this.MyTeams('Reportees', this.ProfileID);
      this.MyTeams('Profile', this.ProfileID);
    }
    //console.log(data);
  }
}
